import { Route, Switch, useRouteMatch } from 'react-router-dom'
import EnergySystemValueProp from './value-prop'
import SelectEnergySystemDevicePage from './select'
import TeslaEnergySystemPermissionsStatementPage from './select/tesla/permissions-statement'
import { useShowEnergySystem } from '@/app/hooks/useShowEnergySystem'
import BrandNotFoundEnergySystemPageSurvey from './not-found'

export default function EnergySystemRoutes() {
  const { path } = useRouteMatch()

  const shouldShowEnergySystem = useShowEnergySystem()

  if (!shouldShowEnergySystem) {
    return null
  }

  return (
    <Switch>
      <Route
        exact
        path={`${path}/connect/select/tesla/permissions-statement`}
        component={TeslaEnergySystemPermissionsStatementPage}
      />
      <Route
        exact
        path={`${path}/connect/not-found`}
        component={BrandNotFoundEnergySystemPageSurvey}
      />
      <Route
        exact
        path={`${path}/connect/select`}
        component={SelectEnergySystemDevicePage}
      />
      <Route exact path={`${path}/connect`} component={EnergySystemValueProp} />
    </Switch>
  )
}
